export default __webpack_public_path__ + "static/media/alonetogether_demo_image.1b938831.png";